<template>
  <div class="book-statistics">
    <div class="module-header">
      <h3 class="module-title">图书多元</h3>
      <div class="time-selector">
        <button 
          v-for="option in timeOptions" 
          :key="option.value"
          :class="['time-btn', { active: tushuduoyuan.period === option.value }]"
          @click="changePeriod(option.value)"
        >
          {{ option.label }}  
        </button>
      </div>
    </div>

    <div class="statistics-grid">
      <!-- 交易笔数 -->
      <div class="stat-card">
        <div class="ring-icon">
          <span class="ring-border" :class="{ spinning: shouldSpin }"></span>
          <span class="ring-inner icon-building"></span>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ formatNumber(transactionCount) }}</div>
          <div class="stat-label">交易笔数(笔)</div>
        </div>
      </div>

      <!-- 总码洋 -->
      <div class="stat-card">
        <div class="ring-icon">
          <span class="ring-border" :class="{ spinning: shouldSpin }"></span>
          <span class="ring-inner icon-yen"></span>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ formatAmountWan(totalAmountWan) }}</div>
          <div class="stat-label">总码洋(万)</div>
        </div>
      </div>

      <!-- 同比 -->
      <div class="stat-card">
        <div class="ring-icon">
          <span class="ring-border" :class="{ spinning: shouldSpin }"></span>
          <span class="ring-inner icon-yoy"></span>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ formatPercent(yoyPercent) }}</div>
          <div class="stat-label">同比</div>
        </div>
      </div>

      <!-- 环比 -->
      <div class="stat-card">
        <div class="ring-icon">
          <span class="ring-border" :class="{ spinning: shouldSpin }"></span>
          <span class="ring-inner icon-mom"></span>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ formatPercent(momPercent) }}</div>
          <div class="stat-label">环比</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BookStatistics',
  data() {
    return {
      chart: null,
      timeOptions: [
        { label: '今日', value: 'today' },
        { label: '本周', value: 'week' },
        { label: '本月', value: 'month' }
      ]
    }
  },
  computed: {
    ...mapState('book', ['tushuduoyuan']),
    ...mapState(['loading']),
    // 当前选择时间段的数据（日/周/月）
    currentPeriodData() {
      const period = this.tushuduoyuan?.period || 'today'
      if (period === 'week') return this.tushuduoyuan.week || {}
      if (period === 'month') return this.tushuduoyuan.month || {}
      return this.tushuduoyuan.day || {}
    },
    shouldSpin() {
      // 当不在加载中且关键数据已存在时触发旋转动画
      const hasData = (
        (this.currentPeriodData && (
          Number(this.currentPeriodData.jybs) > 0 ||
          Number(this.currentPeriodData.zmy) > 0 ||
          Number(this.currentPeriodData.tbzmy) > 0 ||
          Number(this.currentPeriodData.hbzmy) > 0
        ))
      )
      return !this.loading && hasData
    },
    transactionCount() {
      const n = Number(this.currentPeriodData?.jybs)
      return isNaN(n) ? 0 : n
    },
    totalAmountWan() {
      const amt = Number(this.currentPeriodData?.zmy) || 0
      // 转为万单位展示
      return amt / 10000
    },
    yoyPercent() {
      const zmy = Number(this.currentPeriodData?.zmy) || 0
      const baseline = Number(this.currentPeriodData?.tbzmy) || 0
      if (!baseline) return 0
      // 同比 = (总码洋 - 同比总码洋) / 同比总码洋 * 100
      return ((zmy - baseline) / baseline) * 100
    },
    momPercent() {
      const zmy = Number(this.currentPeriodData?.zmy) || 0
      const baseline = Number(this.currentPeriodData?.hbzmy) || 0
      if (!baseline) return 0
      // 环比 = (总码洋 - 环比总码洋) / 环比总码洋 * 100
      return ((zmy - baseline) / baseline) * 100
    }
  },
  methods: {
    formatNumber(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + '万'
      }
      return num.toLocaleString()
    },
    formatAmountWan(num) {
      const n = Number(num) || 0
      return n.toFixed(2)
    },
    formatPercent(num) {
      const n = Number(num) || 0
      return `${n.toFixed(0)}%`
    },
    changePeriod(period) {
      // 更新全局 store 的时间段，以联动展示的数据
      this.$store.commit('book/SET_TUSHUDUOYUAN', { period })
    }
  }
}
</script>

<style lang="scss" scoped>
.book-statistics {
  height: 100%;
  display: flex;
  flex-direction: column;

  .statistics-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 100px;
    box-sizing: border-box;
    padding: 6px 0 16px;
    gap: 0 8px;

    .stat-card {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px 16px;
      padding-right: 0;
      position: relative;

      .ring-icon {
        position: relative;
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 64px;

        .ring-border {
          width: 100%;
          height: 100%;
          background: url("@/assets/images/dy_img.png") no-repeat center center;
          background-size: 100% auto;
          position: absolute;
          left: 0;
          top: 0;
          will-change: transform;
        }

        .ring-border.spinning {
          animation: ring-rotate 3s linear infinite;
        }

        .ring-inner {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .icon-yen::before {
          content: "";
          display: block;
          width: 12px;
          height: 16px;
          background: url("@/assets/images/dy_icon_02.png") no-repeat center center;
          background-size: 100% auto;
        }
        .icon-building::before {
          content: "";
          display: block;
          width: 18px;
          height: 19px;
          background: url("@/assets/images/dy_icon_01.png") no-repeat center center;
          background-size: 100% auto;
        }
        .icon-yoy::before { 
          content: "";
          display: block;
          width: 23px;
          height: 16px;
          background: url("@/assets/images/dy_icon_03.png") no-repeat center center;
          background-size: 100% auto;
        }
        .icon-mom::before { 
          content: "";
          display: block;
          width: 16px;
          height: 17px;
          background: url("@/assets/images/dy_icon_04.png") no-repeat center center;
          background-size: 100% auto;
        }
      }

      .stat-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 1;
        gap: 14px;

        .stat-value {
          font-size: 26px;
          font-weight: 800;
          color: #ffffff;
        }

        .stat-label {
          font-size: 12px;
          color: #FFF;
        }
      }
    }
  }
}
@keyframes ring-rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>